module.exports = __webpack_public_path__ + "static/media/home-plant.c9cc0d45.jpg";